import { validSrc } from 'Misc/validators';
import * as is from 'Misc/is';
import { replaceMacros } from 'Misc/format';
import * as MediaFormats from 'Media/MediaFormats';
import { getIcon } from 'Misc/icon-parsers';

export const parseXML = (xmlString = '') => {
  if(xmlString === '') {
    throw new Error('unable to parse XML. empty string');
  }

  if('DOMParser' in window) {
    return new DOMParser().parseFromString(xmlString, 'application/xml');
  } else {
    throw new Error('DOMParser unavailable');
  }
};

export const vastToConfig = xml => {
  let Media;
  xml = parseXML(xml);

  const mediaFileTags    = getTag(xml, 'MediaFile'),
        impressionTags   = getTag(xml, 'Impression'),
        errorTags        = getTag(xml, 'Error'),
        trackingTags     = getTag(xml, 'Tracking'),
        clickThroughTags = getTag(xml, 'ClickThrough'),
        clickTags        = getTag(xml, 'ClickTracking'),
        wrapperTags      = getTag(xml, 'VASTAdTagURI'),
        iconTags         = getTag(xml, 'Icon');

  if(wrapperTags.length) {
    Media = wrapperTags.map(setXMLMIME).map(getMedia);
  } else {
    Media = mediaFileTags.filter(validFormats).sort(prioritizeVPAIDThenBitrate).map(getMedia);
  }

  return {
    Media,
    UI     : {
      click : clickThroughTags.map(contents).join(''),
      icons : iconTags.map(getIcon)
    },
    Events : {
      impression : impressionTags.map(tagToPixel).filter(validSrc),
      p_0        : getPixelsFromTags(trackingTags,'start'),
      p_25       : getPixelsFromTags(trackingTags,'firstQuartile'),
      p_50       : getPixelsFromTags(trackingTags,'midpoint'),
      p_75       : getPixelsFromTags(trackingTags,'thirdQuartile'),
      p_100      : getPixelsFromTags(trackingTags,'complete'),
      mute       : getPixelsFromTags(trackingTags,'mute'),
      unmute     : getPixelsFromTags(trackingTags,'unmute'),
      pause      : getPixelsFromTags(trackingTags,'pause'),
      resume     : getPixelsFromTags(trackingTags,'resume'),
      fullscreen : getPixelsFromTags(trackingTags,'fullscreen'),
      error      : errorTags.map(tagToPixel).filter(validSrc),
      click      : clickTags.map(tagToPixel).filter(validSrc)
    }, 
    External_VAST : {
      AdParameters : getTagContents(xml, 'AdParameters')
    }
  }
};

export const getPixelsFromTags = (tag, tagName) => tag.filter(filterEvent(tagName)).map(tagToPixel).filter(validSrc);

export const getMedia = element => ({ src: contents(element), format: extractFormat(element.getAttribute('type')), mime: element.getAttribute('type') });

export const extractFormat = (type = '') => {
  if(type.match(/mp4/)) {
    return MediaFormats.FILE;
  } else if(type.match(/javascript/)) {
    return MediaFormats.VPAID;
  } else if(type.match(/flash/)) {
    return MediaFormats.FLASH;
  } else if(type.match(/xml/)) {
    return MediaFormats.VAST;
  } else {
    return MediaFormats.UNKNOWN;
  }
};

export const setXMLMIME                 = tag => { tag.setAttribute && tag.setAttribute('type', 'application/xml'); return tag };
export const validFormats               = tag => tag.getAttribute && tag.getAttribute('type').match(/mp4|javascript|flash/);
export const sortBitrate                = (tagA, tagB) => tagA.getAttribute('bitrate') - tagB.getAttribute('bitrate');
export const prioritizeVPAIDThenBitrate = (tagA, tagB) => {
  const typeA = tagA.getAttribute('type'),
        typeB = tagB.getAttribute('type');

  if(typeA.match(/javascript/) && !typeB.match(/javascript/)) {
    return -1;
  } else if(typeB.match(/javascript/) && !typeA.match(/javascript/)){
    return 1;
  } else {
    return sortBitrate(tagA, tagB);
  }
};

export const getTag = (parent, tagName) => Array.from(parent.getElementsByTagName(tagName));
export const getTagContents = (parent, tagName) => getTag(parent, tagName).map(contents).join('');

export const contents = (tag = {}) => {
  let inner = '';

  if(tag.textContent) {
    return tag.textContent.trim();
  } else if(tag.innerHTML) {
    inner = tag.innerHTML.trim();
  } else if(tag.innerText) {
    inner = tag.innerText.trim();
  }

  inner = stripCDATA(inner);
  inner = replaceMacros(inner, { CACHEBUSTER: new Date().getTime() }, '%%', '%%');

  return stripCDATA(inner);
};
export const tagToPixel  = (tag = '') => ({ src: contents(tag), format: 'pixel' });
export const filterEvent = (eventName = '') => tag => tag.getAttribute('event') === eventName;
export const stripCDATA  = (str = '') => str.replace(/<!\[CDATA\[([0-9A-z/:.?=&\[\]\-\%\$\_\~\@\#\*\+\;\!\'\(\)\,\"\{\}\:\/\s]+)\]\]>/, '$1');


// WEBPACK FOOTER //
// ./src/Services/Misc/parsers.js